import { render, staticRenderFns } from "./OrderPaymentRedirectionDialog.vue?vue&type=template&id=7f3baaba&scoped=true"
import script from "./OrderPaymentRedirectionDialog.vue?vue&type=script&lang=ts"
export * from "./OrderPaymentRedirectionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3baaba",
  null
  
)

export default component.exports